// extracted by mini-css-extract-plugin
export default {"title":"ddb296dc44","bld":"e9f8b8705c"};